import { render, staticRenderFns } from "./ButtonDownloader.vue?vue&type=template&id=53be7e2c&scoped=true&"
import script from "./ButtonDownloader.vue?vue&type=script&lang=js&"
export * from "./ButtonDownloader.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDownloader.vue?vue&type=style&index=0&id=53be7e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be7e2c",
  null
  
)

export default component.exports